import { render, staticRenderFns } from "./ArticlesPicker.vue?vue&type=template&id=0c99df54&scoped=true&"
import script from "./ArticlesPicker.vue?vue&type=script&lang=js&"
export * from "./ArticlesPicker.vue?vue&type=script&lang=js&"
import style0 from "./ArticlesPicker.vue?vue&type=style&index=0&id=0c99df54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c99df54",
  null
  
)

export default component.exports